import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { storage } from '@/utils/storage';
import { projectName } from '@/utils/config';

export default [
  {
    path: '/IFPageOneHSixtyOnePreLogin',
    name: 'IFPageOneHSixtyOnePreLogin',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyOne/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (
        from.path === '/IFPageOneHSixtyOneLogin' ||
        from.path === '/IFPageOneHSixtyOneLoginSecond'
      ) {
        window.history.back();
      } else {
        next();
      }
    },
  },
  {
    path: '/IFPageOneHSixtyOneLogin',
    name: 'pageOneHSixtyOneLogin',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyOne/login.vue'),
  },
  {
    path: '/IFPageOneHSixtyOneLoginLoading',
    name: 'pageOneHSixtyOneLoginLoading',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyOne/loginLoading.vue'),
  },
  {
    path: '/IFPageOneHSixtyOneLeaveInfo',
    name: 'pageOneHSixtyOneLeaveInfo',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyOne/leaveInfo.vue'),
  },
  {
    path: '/IFPageOneHSixtyOneResult',
    name: 'pageOneHSixtyOneResult',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyOne/result.vue'),
  },
  {
    path: '/IFPageOneHSixtyOneLoading',
    name: 'pageOneHSixtyOneLoading',
    component: () => import('@/pages/pageListAll/pageOneHSixtyOne/loading.vue'),
    meta: {
      title: '额度检测',
    },
  },
  {
    path: '/IFPageOneHSixtyOneLoginSecond',
    name: 'pageOneHSixtyOneLoginSecond',
    component: () => import('@/pages/pageListAll/pageOneHSixtyOne/loginSecond.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHSixtyOneOnline',
    name: 'pageOneHSixtyOneOnline',
    component: () => import('@/pages/pageListAll/pageOneHSixtyOne/online.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 网贷来源页 */
      if (from.path == '/IFPageOneHSixtyOneLoginSecond') {
        storage.setItem('onlineGoApply', null);
      } else {
        to.query.time = `${new Date().getTime()}`;
      }
      next();
    },
  },
  {
    path: '/IFPageOneHSixtyOneGuide',
    name: 'pageOneHSixtyOneLoginGuide',
    component: () => import('@/pages/pageListAll/pageOneHSixtyOne/guide.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      to.query.formUrl = from.path;
      next();
    },
  },
  {
    path: '/IFPageOneHSixtyOneCar',
    name: 'pageOneHSixtyOneCar',
    component: () => import('@/pages/pageListAll/pageOneHSixtyOne/car.vue'),
    meta: {
      title: '补充留资',
    },
  },
  {
    path: '/IFPageOneHSixtyOneCarDetails',
    name: 'pageOneHSixtyOneCarDetails',
    component: () => import('@/pages/pageListAll/pageOneHSixtyOne/carDetails.vue'),
    meta: {
      title: '申请结果',
    },
  },
  {
    path: '/IFPageOneHSixtyOneBlank',
    name: 'pageOneHSixtyOneBlank',
    component: () => import('@/pages/pageListAll/pageOneHSixtyOne/blank.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHSixtyOneOnlineTab',
    name: 'pageOneHSixtyOneOnlineTab',
    component: () => import('@/pages/pageListAll/pageOneHSixtyOne/onlineTab.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHSixtyOneOnlineAd',
    name: 'pageOneHSixtyOneOnlineAd',
    component: () => import('@/pages/pageListAll/pageOneHSixtyOne/onlineAd.vue'),
    meta: {
      title: projectName,
    },
  },
];
